const editAddresses = () => {
  const toggle = (content, t) => {
    content.querySelector('.lines').style.display = t ? 'none' : 'block';
    content.querySelector('.edit').style.display = t ? 'none' : 'block';
    content.querySelector('form').style.display = t ? 'block' : 'none';
    content.querySelector('.btn.cancel').style.display = t ? 'block' : 'none';
  }

  const handleEditClick = (e) => {
    e.preventDefault();
    const { parentNode } = e.currentTarget.parentNode;
    const content = parentNode.querySelector('.content');

    toggle(content, true);
  };

  const handleCancelClick = (e) => {
    e.preventDefault();
    const { parentNode } = e.currentTarget.parentNode;
    const content = parentNode.querySelector('.content');

    toggle(content, false);
  }

  const init = () => {
    const editAddressButtons = document.querySelectorAll('.addresses .address .btn.edit');
    editAddressButtons.forEach(current => current.addEventListener('click', handleEditClick));

    const cancelButtons = document.querySelectorAll('.addresses .address .btn.cancel');
    cancelButtons.forEach(current => current.addEventListener('click', handleCancelClick));

    // Toggle currently edited address.
    const urlParams = new URLSearchParams(window.location.search);
    const addressCurrentlyEdited = urlParams.get('edit');

    if (addressCurrentlyEdited) {
      const content = document.querySelector(`.addresses .address.${addressCurrentlyEdited}`);
      if (content) toggle(content, true);
    }
  };

  init();
};

export default editAddresses;
